var map = {
	"./de/general11/slide4.svg": 914,
	"./en/general11/slide4.svg": 476702,
	"./es/general11/slide4.svg": 380661,
	"./fr/general11/slide4.svg": 497181,
	"./nl/general11/slide4.svg": 6499,
	"./pt/general11/slide4.svg": 515689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806944;